import httpManager from "@/app/shared/utils/httpManager";
import { HelpCenterItem } from "@/@types/entities/helpcenter";

class HelpCenterManager {
  private resource = "/help-center";

  async getHelpCenterInfo(type: string): Promise<HelpCenterItem> {
    const response = await httpManager.get(`${this.resource}?type=${type}`);
    return response.data;
  }
}

export const helpCenterManager = new HelpCenterManager();
